// extracted by mini-css-extract-plugin
export default {"cursor":"CustomCursor_cursor__r37hG","visible":"CustomCursor_visible__UmyDm","label":"CustomCursor_label__ANf7j","float":"CustomCursor_float__RYyPA"};